"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateWrapper = exports.TitleTypography = exports.BrandLogoWrapper = exports.BodyWrapper = exports.StyledMedia = exports.Footer = exports.StyledTag = exports.TagWrapper = exports.TappableCardButton = exports.StyledColorPair = exports.classes = void 0;
const Button_1 = require("@mui/material/Button");
const ButtonBase_1 = require("@mui/material/ButtonBase");
const styles_1 = require("@mui/material/styles");
const button_1 = __importDefault(require("../button"));
const color_pair_1 = __importDefault(require("../color-pair"));
const media_1 = __importDefault(require("../media"));
const tag_1 = __importDefault(require("../tag"));
const typography_1 = __importDefault(require("../typography"));
const PREFIX = "TappableCard";
exports.classes = {
    root: `${PREFIX}-root`,
    highlighted: `${PREFIX}-highlighted`,
    brandLogo: `${PREFIX}-brandLogo`,
    negative: `${PREFIX}-negative`,
    headerPicture: `${PREFIX}-headerPicture`,
    headerVideo: `${PREFIX}-headerVideo`,
    contain: `${PREFIX}-contain`,
    body: `${PREFIX}-body`,
    title: `${PREFIX}-title`,
    subtitle: `${PREFIX}-subtitle`,
    noBrandLogo: `${PREFIX}-noBrandLogo`,
    text: `${PREFIX}-text`,
    footer: `${PREFIX}-footer`,
    cardButton: `${PREFIX}-cardButton`
};
exports.StyledColorPair = (0, styles_1.styled)(color_pair_1.default)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
    [`&.${exports.classes.highlighted}`]: {
        border: `3px solid ${theme.colours.inter}`,
        [`.${exports.classes.brandLogo}`]: {
            marginLeft: "0px"
        }
    },
    /* override BaseButton styles */
    alignItems: "normal",
    textAlign: "initial",
    transition: "opacity 280ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
        boxShadow: "0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
        [`.${exports.classes.headerPicture}`]: {
            opacity: 1
        },
        [`.${exports.classes.title}`]: {
            color: theme.colours.focus
        },
        [`.${exports.classes.text}`]: {
            color: theme.colours.charcoal
        }
    },
    [`.${exports.classes.title}, .${exports.classes.text}`]: {
        transition: "color 280ms cubic-bezier(0.4, 0, 0.2, 1)"
    },
    [`.${exports.classes.negative}`]: {
        marginTop: "-50px",
        "& svg, img": {
            backgroundColor: theme.colours.white
        }
    },
    [`.${exports.classes.noBrandLogo}`]: {
        marginTop: 0
    },
    [`.${exports.classes.text}`]: {
        color: theme.colours.slate,
        marginTop: "18px",
        wordWrap: "break-word"
    }
}));
exports.TappableCardButton = (0, styles_1.styled)(button_1.default)(({ theme }) => ({
    backgroundColor: "unset",
    padding: 0,
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    height: "100%",
    color: "unset",
    [`&.${Button_1.buttonClasses.text}:hover`]: {
        backgroundColor: "transparent"
    },
    [`.${ButtonBase_1.touchRippleClasses.root}`]: {
        zIndex: 3
    },
    [`.${ButtonBase_1.touchRippleClasses.child}`]: {
        backgroundColor: `${theme.colours.black}!important`
    }
}));
exports.TagWrapper = (0, styles_1.styled)("div")({
    position: "absolute"
});
exports.StyledTag = (0, styles_1.styled)(tag_1.default)({
    position: "absolute",
    left: 0,
    top: "12px",
    zIndex: 1
});
exports.Footer = (0, styles_1.styled)("div")({
    padding: "6px 30px 30px",
    marginTop: "auto"
});
exports.StyledMedia = (0, styles_1.styled)(media_1.default)({
    height: "180px",
    opacity: 0.8,
    transition: "opacity 280ms cubic-bezier(0.4, 0, 0.2, 1)",
    flexShrink: 0,
    "&:hover": {
        opacity: 1
    },
    [`&.${exports.classes.contain}`]: {
        objectFit: "contain"
    }
});
exports.BodyWrapper = (0, styles_1.styled)("div")({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "30px 30px",
    width: "100%",
    /* override BaseButton styles */
    alignItems: "normal",
    textAlign: "initial"
});
exports.BrandLogoWrapper = (0, styles_1.styled)("div")(({ theme }) => ({
    marginLeft: "-10px",
    height: "40px",
    zIndex: 2,
    overflow: "hidden",
    "& svg, img": {
        paddingLeft: "10px !important",
        paddingRight: "10px !important",
        fill: theme.colours.white,
        height: "100%",
        objectFit: "contain",
        objectPosition: "left"
    }
}));
exports.TitleTypography = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    color: theme.colours.inter,
    marginTop: "18px",
    wordWrap: "break-word"
}));
exports.DateWrapper = (0, styles_1.styled)("div")({
    marginTop: "auto"
});
//# sourceMappingURL=data:application/json;base64,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